import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Crest } from "src/app/classes/crest";
import { CrestService } from "src/app/services/crest.service";


@Component({
  selector: 'app-crest-single',
  templateUrl: './crest-single.component.html',
  styleUrls: ['./crest-single.component.scss']
})
export class CrestSingleComponent implements OnInit {
    
    busy: Subscription;
    pathList: string[][];
    id: number
    single: Crest;
    CrestPart = "Nuovo Stemma"
    constructor (private ar: ActivatedRoute, private router: Router, public CrestService: CrestService) {
      this.pathList = [['stemmi', 'crest/list']];
    }
    loga($event) {
      this.pathList.push($event);
      console.log($event)
    }

    ngOnInit(): void {
          this.id = parseInt(this.ar.snapshot.paramMap.get('id'), 10);
          this.single = new Crest();
          
    }
}